import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const FounderMessage = () => {
  const [cmsData, setCmsData] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [footerData, setFooterData] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (item) => {
     setSelectedItem(item);
    setShow(true);
  };

  useEffect(() => {
    fetchCMSData();
    fetchFooterData();
  }, []);

  const fetchCMSData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cmslist`);
      setCmsData(res.data.data || []);
      setImagePath(res.data.imagePath || "");
    } catch (error) {
      console.error("Error fetching CMS data:", error);
    }
  };

  const fetchFooterData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setFooterData(res.data.data || {});
    } catch (error) {
      console.error("Error fetching footer data:", error);
    }
  };

  const aboutUsItems = cmsData.filter(
    (item) => item.type === "founder_message"
  );
  console.log(aboutUsItems);
  if (footerData.founderpermission !== 1) return null;
  const displayItems =
    aboutUsItems.length === 0
      ? [...aboutUsItems, ...aboutUsItems]
      : aboutUsItems;

  return (
    <section className="bg-light py-60 founder_messege">
      <Container>
        {displayItems.map((item, index) => (
          <div key={index}>
            <Row className="align-items-center">
              <Col md={5} className="mb-4 mb-md-0 order_Second">
                <motion.div
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                >
                  <div className="text-center">
                    {item?.image && (
                      <img
                        src={`${imagePath}${item.image}`}
                        alt={item.name || "Founder"}
                        className="founder_img img-fluid rounded shadow"
                      />
                    )}
                    {item?.name && <h5 className="mt-3 mb-1">{item.name}</h5>}
                    {item?.founder_post && (
                      <small className="text-muted">{item.founder_post}</small>
                    )}
                    <div className="d-flex justify-content-center mt-2">
                    <Link
                      onClick={() => handleShow(item)}
                      className="educate-btn sm"
                    >
                      <span className="educate-btn__curve"></span>
                      More Detail
                    </Link>
                  </div>
                  </div>
                </motion.div>
              </Col>

              <Col md={7}>
                <div className="sec-title pe-2">
                  <h6 className="color-primary mb-16">–––– Founder Message</h6>
                  <div className="p-4 bg-white rounded founder_messege_box">
                    <div className="text-primary mb-3">
                      <FaQuoteLeft size={30} className="quote" />
                    </div>
                    <p
                      className="lead fst-italic"
                      dangerouslySetInnerHTML={{
                        __html: item.description || "",
                      }}
                    />
                    <div className="text-primary mb-3">
                      <FaQuoteRight size={30} className="quote2" />
                    </div>
                    {/* <img
                      src={sign}
                      alt="Signature"
                      width={120}
                      className="mt-3"
                    /> */}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        ))}
      </Container>

      {show && selectedItem && (
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className="enquire_form mentor"
          backdrop="static"
          size="lg"
        >
          <button
            type="button"
            className="custom-close-btn"
            onClick={handleClose}
          >
            ×
          </button>

          <Modal.Body>
            <div className="team__model">
              <Row className="align-items-center">
                <Col lg={5} md={6}>
                  <div className="modal_content_left">
                    <img
                      src={`${imagePath}${selectedItem.image}`}
                      alt={selectedItem?.name}
                      className="team_img"
                    />
                    <div className="mentor_info">
                      <h5 className="mb-8">
                        <Link to="#">{selectedItem?.name}</Link>
                      </h5>
                      <p>{selectedItem?.founder_post}</p>
                    </div>
                  </div>
                </Col>
                <Col lg={7} md={6}>
                  <div className="team_right_info">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: selectedItem?.founder_decription,
                      }}
                    ></p>
                  </div>
                </Col>
              </Row>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </section>
  );
};

export default FounderMessage;
